import React from 'react';
import ComparisonPage from './ComparisonPage';

export default function VsMindbody() {
    return <ComparisonPage slug="mindbody" />;
}
